"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagers = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _outputs = require("./outputs");

var Pagers = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Pagers, _React$Component);

  function Pagers() {
    (0, _classCallCheck2["default"])(this, Pagers);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Pagers).apply(this, arguments));
  }

  (0, _createClass2["default"])(Pagers, [{
    key: "render",
    value: function render() {
      if (this.props.hidden || this.props.children === null || React.Children.count(this.props.children) === 0) {
        return null;
      }

      return React.createElement("div", {
        className: "jsx-4211432262" + " " + "pagers"
      }, React.createElement(_outputs.Outputs, null, this.props.children), React.createElement(_style["default"], {
        styleId: "4211432262",
        css: ".pagers.jsx-4211432262{background-color:var(--theme-pager-bg,#fafafa);}"
      }));
    }
  }]);
  return Pagers;
}(React.Component);

exports.Pagers = Pagers;
(0, _defineProperty2["default"])(Pagers, "defaultProps", {
  children: null,
  hidden: false
});